module.exports = __webpack_public_path__ + "static/media/kiera-knightly-win.73001e0b.jpg";